import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiService } from "src/app/services/api.service";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SearchConsumerService } from "../search-consumer.service";
import { CommonService } from "src/app/services/common.service";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-merge-lead-modal",
  templateUrl: "./merge-lead-modal.component.html",
  styleUrls: ["./merge-lead-modal.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class MergeLeadModalComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  consumerForm = new FormGroup({
    consumerId: new FormControl("", [Validators.required]),
  });
  consumerList: any[] = [];
  filteredOptions: Observable<any>;
  constructor(
    private apiservice: ApiService,
    public dialogRef: MatDialogRef<MergeLeadModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public searchUserService: SearchConsumerService,
    public commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.filteredOptions = this.searchUserService.getAutoCompleteData(
      this.consumerForm.get("consumerId")
    );
  }

  changeConsumer() {
    if (this.consumerForm.valid) {
      let data: any = {
        leadIds: this.data,
        consumerId: this.consumerForm.value?.consumerId,
      };
      this.apiservice
        .post(endpoints.leadManagement.changeConsumer, {
          leadIds: data?.leadIds,
          consumerId: data?.consumerId?.consumerId,
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: HttpResponse<any>) => {
            if (res) {
              this.apiservice.alert(res.body?.message, ErrorType.Success);
              this.dialogRef.close(this.consumerForm.value?.consumerId);
            }
          },
          (err: HttpErrorResponse) => {
            this.apiservice.alert(err.message, ErrorType.Error);
          }
        );
    } else {
      this.consumerForm.markAllAsTouched();
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
